<script>
  export default {
    mounted() {
    },
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/contrato/componentes/Contrato.vue